import { AvailableProgramsSource } from 'reducers/availablePrograms/types';

export enum AVAILABLE_PROGRAMS_ACTION_TYPES {
  LOADING = 'LOADING_AVAILABLE_PROGRAMS',
  LOADED = 'LOADED_AVAILABLE_PROGRAMS',
}

export type FetchAvailableProgramsPayloadType = {
  forceUpdate?: boolean;
  error?: string | null;
};

export const fetchAvailablePrograms = (payload?: FetchAvailableProgramsPayloadType) => ({
  type: AVAILABLE_PROGRAMS_ACTION_TYPES.LOADING,
  payload,
});

export const fetchAvailableProgramsSuccess = (payload: AvailableProgramsSource) => ({
  type: AVAILABLE_PROGRAMS_ACTION_TYPES.LOADED,
  payload,
});
